/**
 * Yaw ↔ ArcRotateCamera.alpha conversion.
 *
 * ArcRotateCamera places the cam at:
 *   target + (cos(α)·sin(β), cos(β), sin(α)·sin(β)) · r
 *
 * To park the cam BEHIND a character with yaw=y (forward = (sin y, 0, cos y))
 * we want cam→target == forward, i.e. cam = target − forward·r, which gives
 *   α = −y − π/2.
 *
 * These two helpers are inverses of each other and are shared by camera.ts
 * (orbit cam) and player.ts (alignYawToCamera after a free-orbit).
 */

export function alphaBehind(yaw: number): number {
  return -yaw - Math.PI / 2;
}

export function yawFromAlpha(alpha: number): number {
  return -alpha - Math.PI / 2;
}
